import { apiClient } from "@/service/ApiClient";

export interface MemberData {
    id: number
    teamId: number
    name: string
    position1: string
    position2?: string
    status: string
}

/** 팀 멤버 목록 */
const getMemberList = async () =>
    apiClient
        .get<MemberData[]>('/member/list')
        .then(res => res.data)

/** 멤버 등록 / 수정 */
const saveMember = async (data: Partial<MemberData>) =>
    apiClient
        .post<MemberData>('/member', data)
        .then(res => res.data)

/** 멤버 삭제 */
const deleteMember = async (id: number) =>
    apiClient.delete(`/member/${id}`)

const MemberService = {
    getMemberList,
    saveMember,
    deleteMember
}


export default MemberService
